import { NgClass, NgForOf, NgIf } from '@angular/common';
import { ChangeDetectorRef, Component, HostListener, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import * as _ from 'lodash';
import { ButtonDirective } from 'primeng/button';
import { Dialog } from 'primeng/dialog';
import { Drawer } from 'primeng/drawer';
import { Tooltip } from 'primeng/tooltip';
import { environment } from '../../../environments/environment';
import { App } from '../../app';
import { ECollection } from '../../enums/ECollection';
import { EShippingType } from '../../enums/EShippingType';
import { IDeepFormat, IQueryFormat } from '../../enums/types';
import { IAddToCart, IAddToCart_P, IAddToCart_S } from '../../interfaces/IAddToCart';
import { IBrand_S } from '../../interfaces/IBrand';
import { IMainCategories, IMainCategories_P, IMainCategories_S } from '../../interfaces/IMainCategories';
import { IModel_S } from '../../interfaces/IModel';
import { IProducts_P, IProducts_S } from '../../interfaces/IProducts';
import { ITodayOffers, ITodayOffers_P, ITodayOffers_S } from '../../interfaces/ITodayOffers';
import { IUser, IUser_P } from '../../interfaces/IUser';
import { IWishlist, IWishlist_P, IWishlist_S } from '../../interfaces/IWishlist';
import { AddToCartService } from '../../service/add-to-cart.service';
import { AuthService } from '../../service/auth.service';
import { ConstantsService } from '../../service/constants.service';
import { EventCenterS } from '../../service/event-center.s';
import { MainCategoriesService } from '../../service/main-categories.service';
import { NotificationService } from '../../service/notification.service';
import { TodayOffersService } from '../../service/today-offers.service';
import { UserService } from '../../service/user.service';
import { UtilsService } from '../../service/utils.service';
import { WishlistService } from '../../service/wishlist.service';
import { ISubCategories_P, ISubCategories_S } from '../../interfaces/ISubCategories';
import { SubCategoriesService } from '../../service/sub-categories.service';
import { LocalCartService } from 'src/app/service/local-cart.service';
import { ProductsService } from 'src/app/service/products.service';
import { ELocalStorage } from '../../enums/ELocalStorage';

declare const $: any;

@Component({
    selector: 'app-header',
    templateUrl: './header.html',
    imports: [ Drawer, NgForOf, ButtonDirective, Tooltip, RouterLink, RouterLinkActive, Dialog, FormsModule, NgIf, ReactiveFormsModule, NgClass ],
    standalone: true,
    styleUrls: [ './header.scss' ]
})
export class Header implements OnInit {
    isPopupVisible: boolean = false;
    loading = { form: false };
    mobileMenuOpen = false;
    visibleCart: boolean = false;
    visibleWishlist: boolean = false;
    visibleOffers: boolean = false;
    displayLogin: boolean = false;
    userInfoDialog: boolean = false;
    checkOutInfo: boolean = false;
    activeMenu: string = '';
    activeItemId: string = '';
    promoCode: string = '';
    mainCategories: IMainCategories[] = [];
    cartList: IAddToCart[] = [];
    cartListMap: { [_id: string]: IAddToCart } = {};
    wishlist: IWishlist[] = [];
    todayOffers: ITodayOffers[] = [];
    fileUrl = environment.FILE_URL;
    shipping: number = 0;
    discount: number = 0;
    myForm!: FormGroup;
    emailPattern: RegExp = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    popupTimer: any = null;
    openDropdownId: string | null = null;

    visibleCoupon: boolean = false;
    selectedCouponId: string | null = null;
    appliedCouponId: string | null = null;

    @HostListener('window:scroll', [])
    onWindowScroll() {
        this.app.isScrolled = window.scrollY > 20;
        this.app.hideTopStrip = window.scrollY > 50;
    }

    dataItem: IUser = <any>{};
    isShowInBox: boolean = false;
    userData: IUser = <any>{};

    constructor(public app: App,
                private router: Router,
                public utilsService: UtilsService,
                public ns: NotificationService,
                public userService: UserService,
                public authService: AuthService,
                public addToCartService: AddToCartService,
                public wishlistService: WishlistService,
                public todayOffersService: TodayOffersService,
                public mainCategoriesService: MainCategoriesService,
                public cs: ConstantsService,
                public cd: ChangeDetectorRef,
                private eventCenterS: EventCenterS,
                private subCategoriesService: SubCategoriesService,
                private fb: FormBuilder,
                private productService: ProductsService,
                private localCartService: LocalCartService
    ) {
        this.createForm();
    }

    async ngOnInit() {
        let defaultAMToken: any = await this.userService.getAMToken();
        window.localStorage.setItem(ELocalStorage.DEFAULT_AM_AUTH, defaultAMToken.token);

        await this.loadMainCategory();
        await this.loadTodayOffers();
        this.eventCenterS.shoLoginDialog.subscribe(async (data: boolean) => {
            if (data) this.openLoginDialog();
        });

        this.eventCenterS.loadAddToCard.subscribe(async (data: boolean) => {
            if (data) this.loadAddToCardList().then();
        });

        this.eventCenterS.loadAddWishlist.subscribe(async (data: boolean) => {
            if (data) this.loadWishListProducts().then();
        });
        this.loadAddToCardList().then();
        this.loadWishListProducts().then();
        this.cd.detectChanges();
        this.router.events.subscribe(() => {
            this.clearBodyScrollLock();
        });
        // this.popupTimer = setTimeout(() => {
        //     this.isPopupVisible = true;
        //     setTimeout(() => {
        //         this.initOfferSlider();
        //     }, 25);
        // }, 50);
    }

    toggleDropdown(id: any) {
        this.openDropdownId = this.openDropdownId === id ? null : id;
    }

    openHome(menu: string) {
        this.router.navigate([ '/home' ]);
        this.mobileMenuOpen = false;
        this.activeMenu = menu;
    }

    // closePopup() {
    //     // @ts-ignore
    //     // document.getElementById("subscribePopup").classList.remove("show");
    //     this.isPopupVisible = false;
    //     this.clearBodyScrollLock();
    // }

    async userShowDialog() {
        this.loading.form = true;
        this.userData = <any>{};
        this.userInfoDialog = true;
        this.myForm.reset();
        this.userData = <any>await this.userService.getByIdUser(<any>this.authService.gUser._id);
        this.myForm.patchValue(this.userData);
        this.loading.form = false;
        this.cd.detectChanges();
    }

    createForm() {
        this.myForm = this.fb.group({
            usr_first_name_str: [ '', Validators.required ],
            usr_last_name_str: [ '', Validators.required ],
            usr_email_str: <any>[ '', Validators.compose([ Validators.required, Validators.pattern(this.emailPattern) ]) ],
            usr_mobile_number_num: <any>[ '', [ Validators.required, Validators.maxLength(10), Validators.minLength(10) ] ],
            // usr_address_str: ['', Validators.required],
        });
    }

    // openPhoneCases(menu: string, mainCategoryId?: string) {
    //     const mainCategoryPSId = this.mainCategories.find(el => el.smc_name_str === 'Phone Cases')?._id
    //     this.router.navigate(['/phone-cases'], { queryParams: { mainCategoryId: mainCategoryPSId } });
    //     this.mobileMenuOpen = false;
    //     // this.activeMenu = menu;
    //     this.activeItemId = <any>mainCategoryId;
    //     window.scrollTo({ top: 0, behavior: 'smooth' });
    // }

    openPhoneCases(
        menu: string,
        mainCategoryId?: string,
        subCategoryId?: string
    ) {
        this.router.navigate([ '/phone-cases' ], {
            queryParams: {
                mainCategoryId,
                subCategoryId
            },
        });
        this.mobileMenuOpen = false;
        // this.activeMenu = menu;
        this.activeItemId = <any>mainCategoryId;
    }

    initOfferSlider() {
        if (typeof $ === 'undefined') return;

        const $owl = $('#owl-carousel4');
        if (!$owl.length) return;

        if ($owl.hasClass('owl-loaded')) {
            $owl.trigger('refresh.owl.carousel');
            return;
        }

        setTimeout(() => {
            $owl.owlCarousel({
                items: 1,
                loop: true,
                nav: true,
                autoplay: true,
                dots: true,
                touchDrag: true,
                mouseDrag: true,
                smartSpeed: 100
            });
        }, 1);
    }


    openOrders(menu: string) {
        if (!this.authService.gUser?._id) return this.openLoginDialog();
        this.router.navigate([ '/orders' ]);
        this.mobileMenuOpen = false;
        this.activeMenu = menu;
    }

    openPhoneCaseMobile(menu: string) {
        this.mobileMenuOpen = false;
        this.activeMenu = menu;
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    openLoginDialog() {
        this.dataItem = <any>{};
        this.isShowInBox = false;
        this.displayLogin = true;
        this.mobileMenuOpen = false;
    }

    toggleMobileMenu() {
        this.mobileMenuOpen = !this.mobileMenuOpen;
    }

    closeMobileMenu() {
        this.mobileMenuOpen = false;
        this.openDropdownId = null;
    }

    copyCoupon(code: string) {
        navigator.clipboard.writeText(code);
    }

    async openOffers() {
        this.isPopupVisible = false;

        if (this.popupTimer) {
            clearTimeout(this.popupTimer);
            this.popupTimer = null;
        }

        this.visibleOffers = true;

        this.mobileMenuOpen = false;

        await this.loadTodayOffers();

        setTimeout(() => this.initOfferSlider(), 1);
    }

    openWishlist() {
        if (!this.authService.gUser?._id) return this.openLoginDialog();
        this.visibleWishlist = true;
        this.loadWishListProducts().then();
    }

    openCart() {
        // if (!this.authService.gUser?._id) return this.openLoginDialog();
        this.visibleCart = true;
        this.loadAddToCardList().then();
    }

    get subtotal() {
        return this.cartList.reduce((sum, item) => sum + item.price * item.qty, 0);
    }

    get total() {
        return this.subtotal + this.shipping - this.discount;
    }

    async increaseQty(item: IAddToCart) {
        // Handle local storage cart for non-logged-in users
        this.removeCoupon();
        if (!this.authService.gUser?._id) {
            const product = {
                atc_product_id: item.atc_product_id._id,
                atc_brand_id: item.atc_brand_id._id || '',
                atc_model_id: item.atc_model_id._id || '',
                atc_color_str: item.atc_color_str
            };
            if (this.localCartService.incrementQty(product)) {
                this.ns.showSuccess('Success');
                await this.loadDataFromLocalStorage();
            }
            this.cd.detectChanges();
            return;
        }

        const formData: IAddToCart = <any>{};
        formData.active = true;
        formData.createdAt = new Date();
        formData.atc_product_id = <any>item.atc_product_id._id;
        formData.atc_user_id = <any>this.authService.gUser?._id;
        formData.atc_model_id = <any>item.atc_model_id._id || '';
        formData.atc_brand_id = <any>item.atc_brand_id._id || '';
        formData.atc_color_str = item.atc_color_str;
        try {
            this.loading.form = true;
            let res = await this.addToCartService.post(formData);
            if (res) {
                this.ns.showSuccess('Success');
                await this.loadAddToCardList();
                await this.applyCode();
                item.qty++;
            }
            this.loading.form = false;
        } catch (e: any) {
            this.loading.form = false;
            this.ns.showErrorFromResponse(e.error || e, 'Unable to increase qty.');
        }
        this.cd.detectChanges();
    }

    async decreaseQty(item: IAddToCart) {
        if (item.qty > 1) {
            this.removeCoupon();
            // Handle local storage cart for non-logged-in users
            if (!this.authService.gUser?._id) {
                const product = {
                    atc_product_id: item.atc_product_id._id,
                    atc_brand_id: item.atc_brand_id._id || '',
                    atc_model_id: item.atc_model_id._id || '',
                    atc_color_str: item.atc_color_str
                };
                if (this.localCartService.decrementQty(product)) {
                    this.ns.showSuccess('Success');
                    await this.loadDataFromLocalStorage();
                }
                this.cd.detectChanges();
                return;
            }

            try {
                this.loading.form = true;
                let query = <IQueryFormat>{
                    find: <IAddToCart_P>{
                        active: true,
                        atc_user_id: this.authService.gUser._id,
                        atc_product_id: item.atc_product_id._id,
                        atc_model_id: item.atc_model_id._id,
                        atc_brand_id: item.atc_brand_id._id,
                        atc_color_str: item.atc_color_str
                    },
                    select: <IAddToCart_S>{
                        atc_product_id: 1,
                        atc_user_id: 1,
                    }
                };
                let res = await this.addToCartService.query(query);
                if (res && res.length) {
                    let resp = await this.addToCartService.permanentDelete(res[0]._id);
                    if (resp) {
                        this.ns.showSuccess('Success');
                        await this.loadAddToCardList();
                        await this.applyCode();
                        item.qty--;
                    }
                }
                this.loading.form = false;
            } catch (e: any) {
                this.loading.form = false;
                this.ns.showErrorFromResponse(e.error || e, 'Unable to decrease qty.');
            }
            this.cd.detectChanges();
        }
    }

    onDrawerShow() {
        // if (this.appliedCouponId) {
        //     // const id = this.appliedCouponId;
        //     // if (!id || !this.todayOffers?.length) return;
        //     // const offer = this.todayOffers.find(o => String(o._id) === String(id));
        //     // if (!offer) return;
        //     this.appliedCouponId = null;
        //     // this.selectOrApply(offer);
        // }
        this.appliedCouponId = null;
        document.body.classList.add('drawer-open');
    }

    onDrawerHide() {
        // document.body.classList.remove('drawer-open');
        this.visibleOffers = false;
        this.visibleCoupon = false;
        this.clearBodyScrollLock();
        this.removeCoupon();
    }

    clearBodyScrollLock() {
        document.body.classList.remove('p-overflow-hidden');
        document.body.classList.remove('drawer-open');
        document.body.style.removeProperty('overflow');
    }

    async applyCode(coupon?: any) {
        if (!this.promoCode) return;

        // prevent applying again
        if (this.appliedCouponId) {
            return this.ns.showError(this.cs.applyCode.appliedCode);
        }

        try {
            this.loading.form = true;
            let query = <IQueryFormat>{
                find: <ITodayOffers_P>{
                    active: true,
                    tdo_code_str: this.promoCode
                },
                select: <ITodayOffers_S>{
                    tdo_code_str: 1,
                    tdo_product_id_arr: 1,
                    tdo_percentage_offers_num: 1
                },
                limit: 1
            };
            let res = await this.todayOffersService.query(query);
            if (res && res.length) {
                let isExistProductCode = res[0].tdo_product_id_arr.find((e: string) => this.cartListMap[e]);
                if (isExistProductCode) {
                    this.discount = Math.floor(this.total / res[0]?.tdo_percentage_offers_num);

                    // ✅ mark coupon as applied
                    this.appliedCouponId = coupon?._id || null;

                    this.ns.showSuccess(this.cs.applyCode.success);
                    this.closeCouponDrawer();
                } else {
                    this.ns.showError(this.cs.applyCode.invalidCode);
                }
            } else {
                this.ns.showError(this.cs.applyCode.invalidCode);
            }
            this.loading.form = false;
        } catch (e: any) {
            this.loading.form = false;
            this.ns.showErrorFromResponse(e.error || e, 'Unable to apply code.');
        }
        this.cd.detectChanges();
    }

    closeCouponDrawer() {
        this.visibleCoupon = false;
        this.clearBodyScrollLock();

        setTimeout(() => {
            document.body.style.overflow = '';
            document.documentElement.style.overflow = '';
        }, 0);
    }

    removeCoupon() {
        this.appliedCouponId = null;
        this.selectedCouponId = null;
        this.promoCode = '';
        this.discount = 0;
    }

    async loadMainCategory() {
        this.loading.form = true;
        this.mainCategories = [];
        let query = <IQueryFormat>{
            find: <IMainCategories_P>{
                active: true,
            },
            select: <IMainCategories_S>{
                smc_name_str: 1,
                smc_order_num: 1,
            },
            sort: <IMainCategories_S>{ smc_order_num: 1 }
        };
        let resp = await this.mainCategoriesService.query(query);
        if (resp && resp.length) {
            let subCategories = await this.loadSubCategory(_.map(resp, '_id'));
            let subCategoriesMap = _.groupBy(
                subCategories,
                'ssc_main_category_id'
            );
            for (let item of resp) {
                if (subCategoriesMap[item._id])
                    item.subCategories = subCategoriesMap[item._id];
            }
        }
        this.mainCategories = resp;
        this.loading.form = false;
        this.cd.detectChanges();
    }

    async loadSubCategory(mainCategoriesIds: string[]) {
        this.loading.form = true;
        let query = <IQueryFormat>{
            find: <ISubCategories_P>{
                active: true,
                ssc_main_category_id: <any>{ $in: mainCategoriesIds },
            },
            select: <ISubCategories_S>{
                ssc_name_str: 1,
                ssc_order_num: 1,
                ssc_main_category_id: 1,
            },
            sort: <ISubCategories_S>{ ssc_order_num: 1 },
        };
        let res = await this.subCategoriesService.query(query);
        this.loading.form = false;
        return res;
    }

    async sendMail() {
        let formData: IUser_P = this.dataItem;
        if (!formData.usr_mobile_number_num && !formData.usr_email_str) return this.ns.showError('Please enter email');
        try {
            this.loading.form = true;
            if (formData.usr_mobile_number_num) delete formData.usr_email_str;
            if (formData.usr_email_str) delete formData.usr_mobile_number_num;
            let res = await this.userService.sendEmailOrMobileWithPin(formData);
            if (res) {
                if (formData.usr_email_str) this.ns.showSuccess(this.cs.user.sendMail);
                if (formData.usr_mobile_number_num) this.ns.showSuccess(this.cs.user.sendSMS);
                this.isShowInBox = true;
            }
            this.loading.form = false;
        } catch (e: any) {
            this.loading.form = false;
            this.ns.showErrorFromResponse(e.error || e, 'Unable to login user.');
        }
        this.cd.detectChanges();
    }

    async login() {
        this.loading.form = true;
        try {
            let userPin: any = '';
            for (let pin of this.utilsService.userPin) {
                userPin = userPin + pin.value;
            }
            let obj = <any>{
                pin: Number(userPin)
            };
            if (this.dataItem.usr_mobile_number_num) obj.usr_mobile_number_num = this.dataItem.usr_mobile_number_num;
            if (this.dataItem.usr_email_str) obj.usr_email_str = this.dataItem.usr_email_str;

            let user = await this.userService.verifyEmailOrMobileWithPin(obj);
            if (user && user.accessToken) {
                this.ns.showSuccess(this.cs.user.pinVerified);
                this.displayLogin = false;
                this.isShowInBox = false;
                this.authService.token.accessToken = user.accessToken;
                this.authService.token.refreshToken = user.refreshToken;
                this.authService.setUserToLocalStorage(user, environment.crypto.passJWT);
                // Sync local cart to database after login
                await this.syncLocalCartToDatabase();
                // this.navigationService.gotoDashboard(this.authService.gUser);
            } else {
                this.loading.form = false;
                this.ns.showError(this.cs.user.pinIncorrect);
            }
        } catch (e: any) {
            this.loading.form = false;
            this.ns.showErrorFromResponse(e.error || e, this.cs.user.pinIncorrect);
        }
    }

    async clickAddToCart(dataItem: IWishlist) {
        if (!this.authService.gUser?._id) return this.openLoginDialog();
        this.loading.form = true;
        const formData: IAddToCart = <any>{};
        formData.active = true;
        formData.createdAt = new Date();
        formData.atc_product_id = <any>dataItem.wis_product_id._id;
        formData.atc_user_id = <any>this.authService.gUser?._id;
        formData.atc_model_id = <any>dataItem.wis_model_id._id || '';
        formData.atc_brand_id = <any>dataItem.wis_brand_id._id || '';
        formData.atc_color_str = dataItem.wis_color_str;
        try {
            this.loading.form = true;
            let res = await this.addToCartService.post(formData);
            if (res) {
                let resp = await this.wishlistService.permanentDelete(<any>dataItem._id);
                if (resp) {
                    this.ns.showSuccess(this.cs.addToCart.success);
                    await this.loadWishListProducts();
                    this.eventCenterS.loadAddToCard.next(true);
                    this.eventCenterS.loadAddWishlistProductDetailsPage.next(true);
                }
            }
            this.loading.form = false;
        } catch (e: any) {
            this.loading.form = false;
            this.ns.showErrorFromResponse(e.error || e, 'Unable to add to card product.');
        }
        this.cd.detectChanges();
    }

    async removedWishListProducts(dataItem: IWishlist) {
        if (!this.authService.gUser?._id) return this.openLoginDialog();
        this.loading.form = true;
        try {
            this.loading.form = true;
            let res = await this.wishlistService.permanentDelete(<any>dataItem._id);
            if (res) {
                this.ns.showSuccess(this.cs.wishlist.remove);
                await this.loadWishListProducts();
            }
            this.loading.form = false;
        } catch (e: any) {
            this.loading.form = false;
            this.ns.showErrorFromResponse(e.error || e, 'Unable to remove data.');
        }
        this.cd.detectChanges();
    }

    async removedAddToCartProducts(dataItem: IAddToCart) {
        // Handle local storage cart for non-logged-in users
        if (!this.authService.gUser?._id) {
            const product = {
                atc_product_id: dataItem.atc_product_id._id,
                atc_brand_id: dataItem.atc_brand_id._id || '',
                atc_model_id: dataItem.atc_model_id._id || '',
                atc_color_str: dataItem.atc_color_str
            };
            if (this.localCartService.removeProduct(product)) {
                this.ns.showSuccess(this.cs.addToCart.remove);
                await this.loadDataFromLocalStorage();
            }
            this.cd.detectChanges();
            return;
        }

        try {
            this.loading.form = true;
            let query = <IQueryFormat>{
                find: <IAddToCart_P>{
                    active: true,
                    atc_user_id: this.authService.gUser._id,
                    atc_product_id: dataItem.atc_product_id._id,
                    atc_model_id: dataItem.atc_model_id._id,
                    atc_brand_id: dataItem.atc_brand_id._id,
                    atc_color_str: dataItem.atc_color_str
                },
            };
            let res = await this.addToCartService.removeByQuery(query);
            if (res) {
                this.ns.showSuccess(this.cs.addToCart.remove);
                await this.loadAddToCardList();
                await this.applyCode();
            }
            this.loading.form = false;
        } catch (e: any) {
            this.loading.form = false;
            this.ns.showErrorFromResponse(e.error || e, 'Unable to remove data.');
        }
        this.cd.detectChanges();
    }

    async loadAddToCardList() {
        if (!this.authService.gUser?._id) {
            this.loadDataFromLocalStorage();
            return;
        }
        ;
        this.loading.form = true;
        this.cartList = [];
        this.discount = 0;
        this.shipping = 0;
        this.promoCode = '';
        let query = <IQueryFormat>{
            find: <IAddToCart_P>{
                active: true,
                atc_user_id: this.authService.gUser._id
            },
            select: <IAddToCart_S>{
                atc_user_id: 1,
                createdAt: 1,
                atc_color_str: 1,
                atc_brand_id: 1,
                atc_model_id: 1,
                atc_product_id: 1,
            },
            deep: [ {
                s_key: "atc_product_id",
                t_instance: environment.INS,
                t_db: environment.DB,
                t_col: ECollection.SW_PRODUCTS,
                t_key: "_id",
                select: <IProducts_S>{
                    pro_name_str: 1,
                    pro_discount_price_num: 1,
                    pro_price_num: 1,
                    // pro_images_color_arr: 1,
                    pro_images_arr: 1,
                    pro_shipping_str: 1,
                    pro_shipping_charges_num: 1
                }
            }, {
                s_key: "atc_brand_id",
                t_instance: environment.INS,
                t_db: environment.DB,
                t_col: ECollection.SW_BRAND,
                t_key: "_id",
                select: <IBrand_S>{ swb_name_str: 1 }
            }, {
                s_key: "atc_model_id",
                t_instance: environment.INS,
                t_db: environment.DB,
                t_col: ECollection.SW_MODEL,
                t_key: "_id",
                select: <IModel_S>{ swm_name_str: 1 }
            } ],
            sort: <IAddToCart_S>{ createdAt: -1 }
        };
        let resp = await this.addToCartService.query(query);
        const map = new Map();
        for (let item of resp) {
            if (item.atc_product_id.pro_images_arr && item.atc_product_id.pro_images_arr.length) {
                const colorArr = item.atc_product_id.pro_images_arr;
                // const uploadPath = colorArr?.[0]?.pro_template_arr?.[0]?.uploadPath;
                // if (uploadPath) item.fileUrl = `${this.fileUrl}${uploadPath}`;
                const uploadPath = colorArr[0]?.uploadPath;
                if (uploadPath) item.fileUrl = `${ this.fileUrl }${ uploadPath }`;
            }
            if (item.atc_product_id.pro_shipping_str === EShippingType.SHIPPING_CHARGES) item.shippingCharge = item.atc_product_id.pro_shipping_charges_num;
            if (item.atc_product_id.pro_shipping_str === EShippingType.FREE_SHIPPING) item.shippingCharge = 0;

            item.product_name = item.atc_product_id.pro_name_str;
            item.productId = item.atc_product_id._id;
            item.price = item.atc_product_id.pro_discount_price_num ? item.atc_product_id.pro_discount_price_num : item.atc_product_id.pro_price_num;
            if (item.atc_product_id.pro_discount_price_num) item.discountPrice = item.atc_product_id.pro_price_num;
            item.model_name = item.atc_model_id.swm_name_str;
            item.brand_name = item.atc_brand_id.swb_name_str;
            const key = `${ item.atc_product_id._id }-${ item.atc_brand_id._id }-${ item.atc_model_id._id }-${ item.atc_color_str }`;
            if (map.has(key)) map.get(key).qty++;
            else map.set(key, { ...item, qty: 1 });
        }
        this.shipping = _.sumBy(resp, 'shippingCharge');
        this.cartListMap = _.keyBy(resp, 'productId');
        this.cartList = Array.from(map.values());
        if (!this.cartList?.length) {
            let getAddToCartData = localStorage.getItem('ADD_TO_CART_DATA');
            if (getAddToCartData) localStorage.removeItem('ADD_TO_CART_DATA');
        }
        this.loading.form = false;
        this.cd.detectChanges();
    }

    async loadDataFromLocalStorage() {
        this.loading.form = true;
        this.cartList = [];
        this.discount = 0;
        this.shipping = 0;
        this.promoCode = '';

        let localCartProducts = this.localCartService.getProducts();
        let productIds: string[] = [];

        // Extract unique product IDs from local cart
        for (let key in localCartProducts) {
            const productId = localCartProducts[key].atc_product_id;
            if (productId && !productIds.includes(productId)) {
                productIds.push(productId);
            }
        }

        if (!productIds.length) {
            this.loading.form = false;
            this.cd.detectChanges();
            return;
        }

        let query = <IQueryFormat>{
            find: <IProducts_P>{
                _id: <any>{ '$in': productIds },
                active: true
            },
            select: <IProducts_S>{
                pro_name_str: 1,
                pro_discount_price_num: 1,
                pro_price_num: 1,
                pro_images_arr: 1,
                pro_shipping_str: 1,
                pro_shipping_charges_num: 1,
                pro_brand_id: 1,
                pro_model_id: 1
            },
            deep: [
                {
                    s_key: "pro_brand_id",
                    t_instance: environment.INS,
                    t_db: environment.DB,
                    t_col: ECollection.SW_BRAND,
                    t_key: "_id",
                    select: <IBrand_S>{ swb_name_str: 1 }
                },
                {
                    s_key: "pro_model_id",
                    t_instance: environment.INS,
                    t_db: environment.DB,
                    t_col: ECollection.SW_MODEL,
                    t_key: "_id",
                    select: <IModel_S>{ swm_name_str: 1 }
                }
            ],
            sort: { createdAt: -1 }
        };

        let resp = await this.productService.query(query);

        // Create a map of products by ID for quick lookup
        const productsMap = _.keyBy(resp, '_id');

        const cartItems: IAddToCart[] = [];
        for (let key in localCartProducts) {
            const cartData = localCartProducts[key];
            const product = productsMap[cartData.atc_product_id];

            if (!product) continue;

            const item: any = { ...product };

            if (item.pro_images_arr && item.pro_images_arr.length) {
                const uploadPath = item.pro_images_arr[0]?.uploadPath;
                if (uploadPath) item.fileUrl = `${ this.fileUrl }${ uploadPath }`;
            }

            if (item.pro_shipping_str === EShippingType.SHIPPING_CHARGES) {
                item.shippingCharge = item.pro_shipping_charges_num;
            } else if (item.pro_shipping_str === EShippingType.FREE_SHIPPING) {
                item.shippingCharge = 0;
            }

            item.product_name = item.pro_name_str;
            item.productId = item._id;
            item.price = item.pro_discount_price_num ? item.pro_discount_price_num : item.pro_price_num;
            if (item.pro_discount_price_num) item.discountPrice = item.pro_price_num;
            item.model_name = item.pro_model_id?.swm_name_str || '';
            item.brand_name = item.pro_brand_id?.swb_name_str || '';
            item.atc_color_str = cartData.atc_color_str;
            item.atc_product_id = { _id: cartData.atc_product_id };
            item.atc_brand_id = { _id: cartData.atc_brand_id };
            item.atc_model_id = { _id: cartData.atc_model_id };
            item.qty = cartData.qty || 1;

            cartItems.push(item);
        }

        this.shipping = _.sumBy(cartItems, 'shippingCharge');
        this.cartListMap = _.keyBy(cartItems, 'productId');
        this.cartList = cartItems;

        if (!this.cartList?.length) {
            let getAddToCartData = localStorage.getItem('ADD_TO_CART_DATA');
            if (getAddToCartData) localStorage.removeItem('ADD_TO_CART_DATA');
        }
        this.loading.form = false;
        this.cd.detectChanges();
    }

    async loadWishListProducts() {
        if (!this.authService.gUser?._id) return;
        this.loading.form = true;
        this.wishlist = [];
        let query = <IQueryFormat>{
            find: <IWishlist_P>{
                active: true,
                wis_user_id: this.authService.gUser._id
            },
            select: <IWishlist_S>{
                createdAt: 1,
                wis_color_str: 1,
                wis_brand_id: 1,
                wis_model_id: 1,
                wis_product_id: 1,
            },
            deep: [ {
                s_key: "wis_product_id",
                t_instance: environment.INS,
                t_db: environment.DB,
                t_col: ECollection.SW_PRODUCTS,
                t_key: "_id",
                select: <IProducts_S>{ pro_name_str: 1, pro_discount_price_num: 1, pro_price_num: 1, pro_images_arr: 1 }
            }, {
                s_key: "wis_brand_id",
                t_instance: environment.INS,
                t_db: environment.DB,
                t_col: ECollection.SW_BRAND,
                t_key: "_id",
                select: <IBrand_S>{ swb_name_str: 1 }
            }, {
                s_key: "wis_model_id",
                t_instance: environment.INS,
                t_db: environment.DB,
                t_col: ECollection.SW_MODEL,
                t_key: "_id",
                select: <IModel_S>{ swm_name_str: 1 }
            } ],
            sort: <IWishlist_S>{ createdAt: -1 }
        };
        let resp = await this.wishlistService.query(query);
        for (let item of resp) {
            if (item.wis_product_id.pro_images_arr && item.wis_product_id.pro_images_arr.length) {
                const colorArr = item.wis_product_id.pro_images_arr;

                // const uploadPath = colorArr?.[0].uploadPath;
                // if (uploadPath) item.fileUrl = `${this.fileUrl}${uploadPath}`;
                const uploadPath = colorArr[0]?.uploadPath;
                if (uploadPath) item.fileUrl = `${ this.fileUrl }${ uploadPath }`;
            }
            item.qty = 1;
            item.product_name = item.wis_product_id.pro_name_str;
            item.price = item.wis_product_id.pro_price_num;
            item.discountPrice = item.wis_product_id.pro_discount_price_num;
            item.model_name = item.wis_model_id.swm_name_str;
            item.brand_name = item.wis_brand_id.swb_name_str;
        }
        this.wishlist = resp;
        this.loading.form = false;
        this.cd.detectChanges();
    }

    async loadTodayOffers() {
        this.loading.form = true;
        this.todayOffers = [];
        let query = <IQueryFormat>{
            find: <ITodayOffers_P>{
                active: true,
            },
            select: <ITodayOffers_S>{
                createdAt: 1,
                tdo_code_str: 1,
                tdo_name_str: 1,
                tdo_description_str: 1,
                tdo_template_arr: 1,
            },
            sort: <ITodayOffers_S>{ createdAt: -1 }
        };
        let resp = await this.todayOffersService.query(query);
        for (let item of resp) {
            if (item.tdo_template_arr && item.tdo_template_arr.length) {
                const uploadPath = item.tdo_template_arr[0]?.uploadPath;
                if (uploadPath) item.fileUrl = `${ this.fileUrl }${ uploadPath }`;
            }
        }
        this.todayOffers = resp;
        this.loading.form = false;
        this.cd.detectChanges();
    }

    async applyCoupon() {
        this.visibleCoupon = true;
        this.appliedCouponId = null;
        await this.loadTodayOffers();
    }

    selectOrApply(coupon: any) {
        // if already applied, do nothing
        if (this.appliedCouponId === coupon._id) return;

        // reset previous discount before applying new coupon
        this.discount = 0;

        // mark selected (for UI)
        this.selectedCouponId = coupon._id;

        // set promo code
        this.promoCode = coupon.tdo_code_str;

        // auto-apply after model update
        setTimeout(async () => {
            await this.applyCode(coupon);
        }, 10);
    }


    checkoutProducts() {
        this.checkOutInfo = true;
    }

    checkoutPage() {
        if (!this.authService.gUser?._id) this.openLoginDialog();
        if (!this.cartList.length) return;
        let getAddToCartData = localStorage.getItem('ADD_TO_CART_DATA');
        if (getAddToCartData) localStorage.removeItem('ADD_TO_CART_DATA');
        localStorage.setItem('ADD_TO_CART_DATA', JSON.stringify({ cartList: this.cartList, discount: this.discount, subtotal: this.subtotal, total: this.total, cartListMap: this.cartListMap }));
        this.eventCenterS.refreshOrderSummary.next({ type: true, promoCodeObj: { _id: this.selectedCouponId, tdo_code_str: this.promoCode } });
        this.router.navigate([ '/checkout' ]).then();
        this.visibleCart = false;
        document.body.classList.remove('drawer-open');
    }

    async updateUser() {
        let formData: IUser_P = this.myForm.getRawValue();
        if (!formData.usr_first_name_str) return this.ns.showError('Please enter first name.');
        if (!formData.usr_last_name_str) return this.ns.showError('Please enter last name.');
        if (!formData.usr_mobile_number_num) return this.ns.showError('Please enter mobile number.');
        if (!formData.usr_email_str) return this.ns.showError('Please enter mobile number.');
        try {
            this.loading.form = true;
            let res = await this.userService.updateUser(<any>this.userData._id, formData, { select: '_id' });
            if (res) {
                this.ns.showSuccess(this.cs.user.editSuccess);
                this.userInfoDialog = false;
                this.userService.gUser.next({ action: 'REFRESH_G_USER' });
            }
            this.loading.form = false;
        } catch (e: any) {
            this.loading.form = false;
            this.ns.showErrorFromResponse(e.error || e, 'Unable to update user.');
        }
        this.cd.detectChanges();
    }

    async syncLocalCartToDatabase() {
        try {
            const localCartProducts = this.localCartService.getProducts();
            const cartKeys = Object.keys(localCartProducts);

            if (!cartKeys.length || !this.authService.gUser?._id) return;

            for (const key of cartKeys) {
                const cartItem = localCartProducts[key];
                const qty = cartItem.qty || 1;

                for (let i = 0; i < qty; i++) {
                    const formData: IAddToCart = <any>{};
                    formData.active = true;
                    formData.createdAt = new Date();
                    formData.atc_product_id = <any>cartItem.atc_product_id;
                    formData.atc_user_id = <any>this.authService.gUser._id;
                    formData.atc_model_id = <any>(cartItem.atc_model_id || '');
                    formData.atc_brand_id = <any>(cartItem.atc_brand_id || '');
                    formData.atc_color_str = cartItem.atc_color_str;

                    await this.addToCartService.post(formData);
                }
            }

            // Clear local cart after syncing
            this.localCartService.clearProducts();

            // Reload cart from database
            await this.loadAddToCardList();
        } catch (e: any) {
            console.error('Error syncing local cart to database:', e);
        }
    }

    isPhoneCase(mainCategoryName: string): boolean {
        return /phone[\s-]*case/i.test(mainCategoryName);
    }

}

